// extracted by mini-css-extract-plugin
var _1 = "TabScrollListButtons-moduleleftArrow__CLngq";
var _2 = "TabScrollListButtons-modulerightArrow__W0uQd";
export { _1 as "leftArrow", _2 as "rightArrow" }
